import type { ElementType } from 'react'

import { useLocation, useNavigate, useParams } from 'react-router-dom'

export function withLegacyRouter<T extends object> (Component: ElementType) {
  return function WithLegacyRouter (props: T): JSX.Element {
    const params = useParams()
    const location = useLocation()
    const navigate = useNavigate()

    return (
      <Component
        {...props}
        params={params}
        location={location}
        navigate={navigate}
      />
    )
  }
}
